import styles from './FriendsPage.module.css';
import FriendsHeader from './FriendsHeader/FriendsHeader.tsx';
import NoFriends from './NoFriends/NoFriends.tsx';
import BalanceTop from '../../components/BalanceTop/BalanceTop.tsx';
import HaveFriends from './HaveFriends/HaveFriends.tsx';
import { useEffect, useState } from 'react';
import { getReferrals } from '../../Requests/referrals/referrals.ts';
import type { WebApp } from '../../types/telegram';
import Loader from '../../components/Loader/Loader.tsx';

interface IReferralsData {
  total_collectable: {
    beastcoins: number;
  };
  current_collectable: {
    beastcoins: number;
  };
  referrals: [
    {
      id: number;
      username: string;
      name: string;
      photo_url: string;
      beasts_earned: number;
    },
  ];
  total_referrals_count: number;
}
interface ExtendedWebApp extends WebApp {
  contentSafeAreaInset?: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
}

const FriendsPage = () => {
  const [referralsData, setReferralsData] = useState<IReferralsData>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const tg = window.Telegram?.WebApp as ExtendedWebApp;
    if (!tg) return;

    console.log(window.Telegram?.WebApp.initData);

    const apply = () => {
      const top = tg?.contentSafeAreaInset?.top ?? 0;
      document.documentElement.style.setProperty(
        '--tg-viewport-content-safe-area-inset-top',
        `${top}px`,
      );
    };

    apply();
    tg.onEvent?.('contentSafeAreaChanged', apply);
    return () => tg.offEvent?.('contentSafeAreaChanged', apply);
  }, []);

  const refreshReferrals = async () => {
    setIsLoading(true);
    const initData = window.Telegram?.WebApp.initData;
    if (initData) {
      const data = await getReferrals(initData);
      setReferralsData(data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    refreshReferrals();
  }, []);

  return (
    <div className={styles.container}>
      {isLoading ? (
          <Loader />
      ) : (
          <div>
            <FriendsHeader />
            <BalanceTop />
            {referralsData?.referrals && referralsData.referrals.length > 0 ? (
                <HaveFriends {...referralsData} refreshReferrals={refreshReferrals} />
            ) : (
                <NoFriends />
            )}
          </div>
      )}
    </div>
  );
};

export default FriendsPage;

